<style scoped>
    .error-container {
        margin-top: 15px;
    }
    .msg-to-bot {
        padding-bottom: 10px;
    }
    .logout-button {
        border: none;
        outline:none;
        background: transparent;
    }
</style>

<template>
    <div>
        <div class="login-box-body">
            <p class="login-box-msg msg-to-bot">
                <a :href="`https://t.me/${bot_login}`" target="_blank">
                    {{ translations.open_bot }}
                </a>
            </p>
            <!-- Logout -->
            <form action="/logout" method="POST">
                <input type="hidden" name="_token" :value="csrf_token">
                <p class="login-box-msg">
                    <button type="submit" class="logout-button">
                        <a>{{ translations.logout }}</a>
                    </button>
                </p>
            </form>
            <div class="row">
                <div class="col-md-12">
                    <!-- Input for typing code -->
                    <div v-if="is_code_sent" class="form-group">
                        <input type="text"
                               class="form-control"
                               @input="onTypingCode"
                               :placeholder="translations.enter_code">
                    </div>

                    <!-- Button to send code -->
                    <button @click="sendCode()"
                            class="btn btn-primary btn-block"
                            :disabled="is_sending_code || time_to_resend > 0"
                    >
                        <span v-if="is_sending_code">
                            <i class="fa fa-spinner fa-spin"></i>
                        </span>
                        <span v-else>{{ translations.send_code }}</span>
                        <span v-if="time_to_resend > 0" v-text="` (${time_to_resend})`"></span>
                    </button>
                </div>
            </div>
        </div>

        <div class="alert alert-danger error-container" v-if="error_message">
            <ul>
                <li v-text="error_message"></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: ['bot_login', 'translations'],
    data() {
        return {
            time_to_resend: 0,

            csrf_token: null,
            error_message: null,
            is_code_sent: false,
            is_sending_code: false,
        }
    },
    created() {
        let csrf_token = document.querySelector('#token').getAttribute('content');

        this.csrf_token = csrf_token;
        Vue.http.headers.common['X-CSRF-TOKEN'] = csrf_token;
    },
    methods: {
        sendCode() {
            this.is_sending_code = true;

            this.$http.post('/2fa/send').then(() => {
                this.is_code_sent = true;
                this.is_sending_code = false;

                this.runResendingTimer();
            }).catch((response) => {
                this.is_code_sent = true;
                this.is_sending_code = false;

                alert(response.data.message);
            });
        },
        onTypingCode(event) {
            let code = event.target.value;

            if (code.length === 5) {
                this.$http.post('/2fa/login', {
                    code: code
                }).then(() => {
                    window.location = this.absoluteUrl('');

                }).catch((response) => {
                    this.error_message = response.data.message;

                    // Too many attempts
                    if (response.status === 429) {
                        window.location = this.absoluteUrl('/blocked');
                    }
                });
            } else {
                this.error_message = null;
            }
        },
        absoluteUrl(path) {
            let a = document.createElement('a');

            a.href = path;

            return a.href;
        },
        runResendingTimer() {
            this.time_to_resend = 20;

            this.decreaseTime();
        },
        decreaseTime() {
            if (this.time_to_resend > 0) {
                this.time_to_resend -= 1;

                setTimeout(this.decreaseTime, 1000);
            }
        }
    }
};
</script>
